// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u_fj","badges":"styles_badges__11cy8"};